/* eslint-disable react-func/max-lines-per-function */
import { AxiosInstance } from 'axios';
import Qs from 'query-string';
import { ActivityApplyInfoBackend } from '../constants';

// eslint-disable-next-line react-func/max-lines-per-function
const getUserServices = ({
  GateWayInstance,
  LoginGateWayInstance,
}: {
  GateWayInstance: AxiosInstance;
  LoginGateWayInstance: AxiosInstance;
}) => ({
  // 用户对指定活动的报名情况
  getUserActivityApplyInfo(aid: string) {
    return GateWayInstance.get<ActivityApplyInfoBackend>(`/users/activity/${aid}`);
  },
  getPlayerActivityApplyInfo(aid: string) {
    return GateWayInstance.get<ActivityApplyInfoBackend>(`/activity_center/player/${aid}`);
  },
  // 修改用户信息
  editUserAccountInfo(data: { [key: string]: string | boolean }) {
    return LoginGateWayInstance.put(`/users/account`, { ...data });
  },
  // 获取验证码
  getMsgCode(phone: string, valid: string) {
    return GateWayInstance.get(`/users/msgcode?${Qs.stringify({ phone, valid })}`);
  },
  // 绑定新手机号
  bindMobile(data: { phone: string; code: string }) {
    return LoginGateWayInstance.post<any>('/users/phone/bind', data);
  },
  // 验证旧手机号
  checkMobile(data: { phone: string; code: string }) {
    return GateWayInstance.post<{ result: boolean }>('/users/phone/check', data);
  },
  // 获取当前账号的所有相关信息
  getAllAccountInfo() {
    return LoginGateWayInstance?.get<{ accounts: Record<string, string> }>(`/users/accounts`);
  },
});

export default getUserServices;
